import React, { useState, useEffect } from 'react';

export default function Accessories() {
  const [timeLeft, setTimeLeft] = useState({
    days: 30,
    hours: 12,
    minutes: 45,
    seconds: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 };
        if (prev.minutes > 0) return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        if (prev.hours > 0) return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        if (prev.days > 0) return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <span style={styles.tag}>New Collection</span>
        <h1 style={styles.title}>Accessories</h1>
        <p style={styles.subtitle}>Coming Soon</p>

        <p style={styles.desc}>
          Premium, handpicked accessories are on the way.
          Be the first to know when we launch.
        </p>

        <div style={styles.timer}>
          <div style={styles.time}>
            <span style={styles.num}>{timeLeft.days}</span>
            <span style={styles.label}>Days</span>
          </div>
          <div style={styles.time}>
            <span style={styles.num}>{timeLeft.hours}</span>
            <span style={styles.label}>Hours</span>
          </div>
          <div style={styles.time}>
            <span style={styles.num}>{timeLeft.minutes}</span>
            <span style={styles.label}>Mins</span>
          </div>
          <div style={styles.time}>
            <span style={styles.num}>{timeLeft.seconds}</span>
            <span style={styles.label}>Secs</span>
          </div>
        </div>

        <form style={styles.form} onSubmit={(e) => e.preventDefault()}>
          <input
            type="email"
            placeholder="Enter your email"
            style={styles.input}
            required
          />
          <button type="submit" style={styles.btn}>
            Notify Me
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '80vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4rem 1.5rem',
    background: '#faf9f6',
  },
  card: {
    maxWidth: '520px',
    width: '100%',
    textAlign: 'center',
    background: '#ffffff',
    border: '1px solid #e8e4dc',
    borderRadius: '20px',
    padding: '3rem 2.5rem',
    boxShadow: '0 2px 4px rgba(26, 24, 20, 0.04), 0 8px 24px rgba(26, 24, 20, 0.08)',
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  tag: {
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '0.24em',
    textTransform: 'uppercase',
    color: '#b08f4a',
    padding: '6px 14px',
    border: '0.5px solid #c8a96e',
    background: 'rgba(200, 169, 110, 0.08)',
    borderRadius: '40px',
    marginBottom: '1.5rem',
  },
  title: {
    fontFamily: "'Cormorant Garamond', Georgia, serif",
    fontSize: 'clamp(32px, 5vw, 48px)',
    fontWeight: 500,
    color: '#1a1814',
    margin: '0 0 0.4rem 0',
    lineHeight: 1.1,
  },
  subtitle: {
    fontFamily: "'Cormorant Garamond', Georgia, serif",
    fontStyle: 'italic',
    fontSize: '20px',
    color: '#c8a96e',
    margin: '0 0 1.2rem 0',
  },
  desc: {
    fontSize: '14px',
    color: '#8a8270',
    lineHeight: 1.7,
    marginBottom: '2rem',
    maxWidth: '400px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  timer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.8rem',
    marginBottom: '2rem',
  },
  time: {
    background: '#f5f2ec',
    border: '1px solid #e8e4dc',
    borderRadius: '8px',
    padding: '12px 16px',
    minWidth: '64px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  num: {
    fontFamily: "'Cormorant Garamond', Georgia, serif",
    fontSize: '24px',
    fontWeight: 600,
    color: '#1a1814',
    lineHeight: 1,
  },
  label: {
    fontSize: '9px',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#8a8270',
    marginTop: '4px',
  },
  form: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  input: {
    flex: '1 1 200px',
    padding: '13px 18px',
    borderRadius: '8px',
    border: '1px solid #ddd6c8',
    background: '#faf9f6',
    color: '#1a1814',
    fontSize: '14px',
    fontFamily: "'DM Sans', sans-serif",
    outline: 'none',
  },
  btn: {
    padding: '13px 28px',
    borderRadius: '8px',
    border: 'none',
    background: '#1a1814',
    color: '#fafaf8',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
  },
};